import Splide from '@splidejs/splide';
import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';

function bannerFullscreen() {

    console.log('Banner Fullscreen block initialized');

    const banners = document.querySelectorAll('.banner_full_screen');

    banners.forEach((banner) => {

        // Initialize Splide gallery if exists
        const gallery = banner.querySelector('.splide--banner-full-screen');

        if (gallery) {
            const splide = new Splide(gallery, {
                type: 'loop',
                autoplay: true,
                interval: 5500,
                arrows: false,
                pagination: true,
                drag: true,
                pauseOnHover: false,
                pauseOnFocus: false,
            });

            splide.mount();
        }

        // Initialize lightGallery for video button if exists
        const videoBtn = banner.querySelector('.banner-full-screen__video-btn');
        
        if (videoBtn) {

            console.log('Initializing lightGallery for video button');
            lightGallery(banner, {
                selector: '.banner-full-screen__video-link',
                plugins: [lgVideo],
                speed: 500,
                controls: true,
                showThumbByDefault: false,
                download: false,
            });
        }
    });

}

function banner() {
    console.log('Banner block initialized');

    const banners = document.querySelectorAll('.banner .block__wrapper');

    banners.forEach((bannerEl) => {
        // Initialize lightGallery for video button if exists
        const videoBtn = bannerEl.querySelector('.banner__video-btn') || bannerEl.querySelector('.banner__buttons .banner__video-btn');
        
        if (videoBtn) {
            console.log('Initializing lightGallery for banner video');
            lightGallery(bannerEl, {
                selector: '.banner__video-link',
                plugins: [lgVideo],
                speed: 500,
                controls: true,
                showThumbByDefault: false,
                download: false,
            });
        }
    });
}


export default bannerFullscreen;
export { banner };